<template>
  <aside class="risk-side">
    <div class="card catchup">
      <div class="card-h">补涨风险</div>
      <div class="catchup-grid">
        <div class="col">
          <div class="col-h">
            <span>{{ catchup.kpl.title }}</span>
            <span class="status" :class="catchup.kpl.statusTone">{{ catchup.kpl.status }}</span>
          </div>
          <ul>
            <li v-for="(r, i) in catchup.kpl.rows" :key="'k' + i">
              <span class="n">{{ r.name }}</span>
              <span class="p" :class="pctClass(r.changePct)">{{ formatPct(r.changePct) }}</span>
            </li>
          </ul>
          <div class="hint">{{ qualityHint(catchup.kpl) }}</div>
        </div>
        <div class="col">
          <div class="col-h">
            <span>{{ catchup.wencai.title }}</span>
            <span class="status" :class="catchup.wencai.statusTone">{{ catchup.wencai.status }}</span>
          </div>
          <ul>
            <li v-for="(r, i) in catchup.wencai.rows" :key="'w' + i">
              <span class="n">{{ r.name }}</span>
              <span class="p" :class="pctClass(r.changePct)">{{ formatPct(r.changePct) }}</span>
            </li>
          </ul>
          <div class="hint">{{ qualityHint(catchup.wencai) }}</div>
        </div>
      </div>
    </div>

    <div class="card env">
      <div class="card-h">市场环境</div>
      <div class="env-body">
        <div class="score">{{ marketEnv.score }} <small>{{ marketEnv.unit }}</small></div>
        <div class="env-meta">{{ marketEnv.asofLabel }} · 待接入</div>
        <div class="spark" aria-hidden="true">
          <span v-for="n in 12" :key="n" :style="{ height: sparkH(n) + '%' }" />
        </div>
      </div>
    </div>

    <div class="card alerts">
      <div class="card-h row">
        <span>状态变化提醒</span>
        <div class="mini-tabs">
          <button type="button" class="on">当前龙头</button>
          <button type="button">全部龙头</button>
        </div>
      </div>
      <ul class="alert-list">
        <li v-for="(a, i) in alerts" :key="i" :class="a.tone">
          <span class="t">{{ a.time }}</span>
          <span class="txt">{{ a.text }}</span>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import riskDemo from '@/data/leaderCommandCenter/riskModeDemo.json'

export default {
  name: 'RiskSidePanel',
  props: {
    catchupRows: { type: Array, default: () => [] }
  },
  computed: {
    catchup() {
      const base = JSON.parse(JSON.stringify(riskDemo.catchupRisk || {}))
      const real = (this.catchupRows || []).slice(0, 5).map((r) => ({
        name: r.name || r.code || '—',
        changePct: r.changePct != null ? r.changePct : null
      }))
      if (real.length) {
        // Prefer real catchup names for Wencai column; keep status as 待接入
        base.wencai.rows = real.map((r) => ({
          name: r.name,
          changePct: r.changePct
        }))
        base.wencai.status = '列表已接入'
        base.wencai.statusTone = 'ok'
        base.wencai.quality = 'CATCHUP_LIST'
        base.kpl.status = '待接入'
        base.kpl.statusTone = 'muted'
        base.kpl.quality = 'NOT_IMPLEMENTED'
        base.kpl.rows = real.slice(0, 3).map((r) => ({
          name: r.name,
          changePct: null
        }))
      }
      return base
    },
    marketEnv() {
      return riskDemo.marketEnv || { score: '—', unit: '', asofLabel: '—' }
    },
    alerts() {
      return riskDemo.alerts || []
    }
  },
  methods: {
    formatPct(v) {
      if (v == null || !Number.isFinite(Number(v))) return '—'
      const n = Number(v)
      const sign = n > 0 ? '+' : ''
      return sign + n.toFixed(2) + '%'
    },
    pctClass(v) {
      if (v == null || !Number.isFinite(Number(v))) return 'flat'
      if (Number(v) > 0) return 'up'
      if (Number(v) < 0) return 'down'
      return 'flat'
    },
    qualityHint(col) {
      if (!col) return '待接入'
      if (col.quality === 'CATCHUP_LIST') return '名称来自观察池补涨列表 · 风险结论待接入'
      if (col.quality === 'NOT_IMPLEMENTED') return '开盘啦风险结论待接入'
      return '布局演示占位'
    },
    sparkH(n) {
      const arr = [35, 42, 38, 55, 48, 60, 52, 45, 58, 50, 40, 46]
      return arr[(n - 1) % arr.length]
    }
  }
}
</script>

<style scoped lang="scss">
.risk-side {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow: auto;
}
.card {
  background: #fff;
  border: 1px solid #d7e4f6;
  border-radius: 12px;
  padding: 12px;
}
.card-h {
  font-size: 13px;
  font-weight: 800;
  color: #1a2b3c;
  margin-bottom: 10px;
  &.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
}
.catchup-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.col {
  border: 1px solid #e8eef8;
  border-radius: 10px;
  padding: 8px;
  background: #fafcff;
}
.col-h {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #35598c;
  margin-bottom: 8px;
}
.status {
  font-size: 11px;
  font-weight: 700;
  &.danger { color: #c62828; }
  &.ok { color: #1aae6f; }
  &.muted { color: #90a4c0; }
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  font-size: 12px;
  padding: 3px 0;
  border-bottom: 1px dashed #eef2f8;
  &:last-child { border-bottom: 0; }
}
.n { color: #1a2b3c; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.p {
  font-weight: 700;
  flex-shrink: 0;
  &.up { color: #e24b4b; }
  &.down { color: #1aae6f; }
  &.flat { color: #90a4c0; }
}
.hint {
  margin-top: 8px;
  font-size: 10px;
  color: #90a4c0;
  line-height: 1.35;
}
.env-body { text-align: left; }
.score {
  font-size: 28px;
  font-weight: 800;
  color: #1a73e8;
  small { font-size: 13px; font-weight: 600; color: #7b93b5; }
}
.env-meta { font-size: 11px; color: #90a4c0; margin: 4px 0 10px; }
.spark {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 36px;
  span {
    flex: 1;
    background: linear-gradient(180deg, #7eb6ff, #1a73e8);
    border-radius: 2px 2px 0 0;
    opacity: 0.75;
    min-height: 4px;
  }
}
.mini-tabs {
  display: flex;
  gap: 4px;
  button {
    border: 0;
    background: #eef3fb;
    color: #7b93b5;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 11px;
    cursor: default;
    &.on { background: #1a73e8; color: #fff; font-weight: 700; }
  }
}
.alert-list li {
  display: flex;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f8;
  font-size: 12px;
  &.warn .txt { color: #e67e22; }
  &.muted .txt { color: #90a4c0; }
  &.info .txt { color: #1a4f8b; }
}
.alert-list .t {
  flex-shrink: 0;
  color: #90a4c0;
  font-weight: 600;
}
</style>
